import React, { useState } from "react";

export default function Pagination({ setPayload, totalRecord }) {
  const totalPages = Math.ceil(totalRecord / 10);
  const [currentPage, setCurrentPage] = useState(1);

  // Handle page change
  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    setPayload((prev) => ({ ...prev, pageNo:page })); // update parent payload
  };

  // Create page number array
  const pageArr = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="">
      <nav aria-label="Page navigation example">
        <ul className="pagination">

          {/* Previous Button */}
          <li className={`page-item  ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link "
              onClick={() => handlePageChange(currentPage - 1)}
              aria-label="Previous"
            >
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>

          {/* Page Numbers */}
          {pageArr.map((page) => (
            <li
              key={page}
              className={`page-item ${currentPage === page ? "active " : ""}`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            </li>
          ))}

          {/* Next Button */}
          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
              aria-label="Next"
            >
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}
